var jquery1_12_4 = {exports: {}};

export { jquery1_12_4 as j };
